import axios from 'axios';
import {getAuthHeader} from  '../global_helpers/authHeader.js';

const state = {
    siteAdmin: {
        RepUserList: [],
    },
};

const getters = {
    getSiteAdminRepUserList: (state) => state.siteAdmin.RepUserList,
};

const actions = {

    async adminCreateRepUser({dispatch}, repuser){
        let authHeader = getAuthHeader();
        axios.post("/repuser/admin/", {repuser:repuser}, authHeader)
        .then(() => {
            dispatch('raiseMessage', `Successfully created ${repuser.rep_name}.`, {root: true});
            dispatch('adminGetRepUserList',repuser.wholesaler_id);
        })
        .catch(err => {
           console.log(err);
           dispatch('raiseMessage', `There was an error creating ${repuser.rep_name}!`, {root: true});
        });
    },
    
    async adminUpdateRepUser({dispatch}, repuser){
        let authHeader = getAuthHeader();
        axios.put("/repuser/admin/", {repuser:repuser}, authHeader)
        .then(() => {
            dispatch('raiseMessage', 'Successfully updated ${repuser.rep_name}!', {root: true});
            dispatch('adminGetRepUserList',repuser.wholesaler_id);
        })
        .catch(err => {
           console.log(err);
           dispatch('raiseMessage', 'There was an error updating ${repuser.rep_name}!', {root: true});
        });
    },

    async adminGetRepUserList({commit, dispatch}, wholesaler_id){
        let authHeader = getAuthHeader();
        axios.get("/repuser/list/?wholesaler_id="+wholesaler_id, authHeader)        
        .then((res) => {
            commit('adminSetRepUserList', res.data);
        })
        .catch(err => {
            console.log(err);
            dispatch('raiseMessage', 'There was an error loading the Wholesaler list!', {root: true});
        });
    },

    async adminClearRepUserLsit({commit}){
        commit('adminClearRepUserList')
    }
};

const mutations = {
    adminSetRepUserList(state, list){
        list.sort((a,b) => a.rep_name.toLowerCase() > b.rep_name.toLowerCase());
        state.siteAdmin.RepUserList = list;
    },

    adminClearRepUserList(state){
        state.siteAdmin.RepUserList = [];
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};